import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
// import { URL } from "@/Redux/common/url";
// import Api from "@/Redux/common/api";
// import { useRouter } from "next/router";

import { useDispatch, useSelector } from "react-redux";
// import { allapiAction } from "@/Redux/common/action";
import Slider from "react-slick";
import { URL } from "../../Redux/common/url";
import Api from "../../Redux/common/api";
import { Link, useNavigate } from "react-router-dom";
import { allapiAction } from "../../Redux/common/action";
import { AsyncPaginate } from "react-select-async-paginate";
import HomeSlider from "../Home/HomeSlider";
import RegisaterSlider from "../Home/RegisaterSlider";
function RegisterComponent() {
  const [type, settype] = useState("User");
  const [userData, setuserData] = useState({
    fullName: "",
    password: "",
    country: "",
  });
  const route = useNavigate();
  const [otp_box, setotpBox] = useState("0");

  const [state, setState] = useState("");
  const [Citys, setCity] = useState("");

  const slider_list = useSelector((state) =>
    state?.allapi?.slider_list ? state?.allapi?.slider_list : {}
  );

  const dispatch = useDispatch();

  console.log(slider_list);
  const slider = slider_list?.sliders ? slider_list?.sliders : [];
  const ad = slider_list?.ads ? slider_list?.ads : [];
  const banner = slider_list?.banner ? slider_list?.banner : [];
  const ads2 = [...slider].reverse();

  console.log(slider);
  console.log(ads2);

  var settings = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const hendletochange = (e) => {
    const { name, value } = e?.target;
    setuserData({ ...userData, [name]: value });
  };

  const hendletoSubmit = async (e) => {
    e.preventDefault();

    if (!userData?.fullName) {
      toast.error("please enter full name");
    } else if (!userData?.phone) {
      toast.error("please enter phone");
    } else {
      const response = await Api.post(`${URL.registerUser}`, {
        fullName: userData?.fullName,
        phone: userData?.phone,
      });

      if (response?.data?.success) {
        // setotpBox("2");
        route("/login");
        toast.success(response?.data?.message);
      } else {
        toast.error(response?.data?.message);
      }
    }
  };

  const [stateselect, setstateselect] = useState(null);
  const [districtselect, setdistrictselect] = useState(null);
  const [cityselect, setcityselect] = useState(null);

  const [mangeKey, setmangeKey] = useState(0);
  const [mangeKey2, setmangeKey2] = useState(0);

  useEffect(() => {
    setmangeKey(mangeKey + 1);
    setmangeKey2(mangeKey2 + 1);
    setdistrictselect(null);
    setcityselect(null);

    return () => { };
  }, [stateselect]);
  useEffect(() => {
    // setmangeKey(mangeKey + 1);
    setmangeKey2(mangeKey2 + 1);
    setcityselect(null);
    return () => { };
  }, [districtselect]);

  const loadOptionsState = async (search, loadedOptions, pages) => {
    console.log(loadedOptions);
    console.log(pages);
    const response = await fetch(
      URL.API_BASE_URL +
      `/publicApi/searchareaStates?key=${search}&page=${pages?.page}`
    );
    const responseJSON = await response.json();

    const options = responseJSON?.results?.map((data) => {
      data.value = data?._id;
      data.label = data?.State;

      return data;
    });

    return {
      options: options,
      hasMore: responseJSON.has_more,
      additional: {
        page: pages?.page + 1,
      },
    };
  };
  const countries = [
    { name: "Afghanistan", dial_code: "+93" },
    { name: "Albania", dial_code: "+355" },
    { name: "Algeria", dial_code: "+213" },
    { name: "American Samoa", dial_code: "+1-684" },
    { name: "Andorra", dial_code: "+376" },
    { name: "Angola", dial_code: "+244" },
    { name: "Anguilla", dial_code: "+1-264" },
    { name: "Antarctica", dial_code: "+672" },
    { name: "Antigua and Barbuda", dial_code: "+1-268" },
    { name: "Argentina", dial_code: "+54" },
    { name: "Armenia", dial_code: "+374" },
    { name: "Aruba", dial_code: "+297" },
    { name: "Australia", dial_code: "+61" },
    { name: "Austria", dial_code: "+43" },
    { name: "Azerbaijan", dial_code: "+994" },
    { name: "Bahamas", dial_code: "+1-242" },
    { name: "Bahrain", dial_code: "+973" },
    { name: "Bangladesh", dial_code: "+880" },
    { name: "Barbados", dial_code: "+1-246" },
    { name: "Belarus", dial_code: "+375" },
    { name: "Belgium", dial_code: "+32" },
    { name: "Belize", dial_code: "+501" },
    { name: "Benin", dial_code: "+229" },
    { name: "Bermuda", dial_code: "+1-441" },
    { name: "Bhutan", dial_code: "+975" },
    { name: "Bolivia", dial_code: "+591" },
    { name: "Bosnia and Herzegovina", dial_code: "+387" },
    { name: "Botswana", dial_code: "+267" },
    { name: "Brazil", dial_code: "+55" },
    { name: "British Indian Ocean Territory", dial_code: "+246" },
    { name: "Brunei", dial_code: "+673" },
    { name: "Bulgaria", dial_code: "+359" },
    { name: "Burkina Faso", dial_code: "+226" },
    { name: "Burundi", dial_code: "+257" },
    { name: "Cambodia", dial_code: "+855" },
    { name: "Cameroon", dial_code: "+237" },
    { name: "Canada", dial_code: "+1" },
    { name: "Cape Verde", dial_code: "+238" },
    { name: "Cayman Islands", dial_code: "+1-345" },
    { name: "Central African Republic", dial_code: "+236" },
    { name: "Chad", dial_code: "+235" },
    { name: "Chile", dial_code: "+56" },
    { name: "China", dial_code: "+86" },
    { name: "Colombia", dial_code: "+57" },
    { name: "Comoros", dial_code: "+269" },
    { name: "Congo", dial_code: "+242" },
    { name: "Cook Islands", dial_code: "+682" },
    { name: "Costa Rica", dial_code: "+506" },
    { name: "Croatia", dial_code: "+385" },
    { name: "Cuba", dial_code: "+53" },
    { name: "Cyprus", dial_code: "+357" },
    { name: "Czech Republic", dial_code: "+420" },
    { name: "Denmark", dial_code: "+45" },
    { name: "Djibouti", dial_code: "+253" },
    { name: "Dominica", dial_code: "+1-767" },
    { name: "Dominican Republic", dial_code: "+1-809" },
    { name: "Ecuador", dial_code: "+593" },
    { name: "Egypt", dial_code: "+20" },
    { name: "El Salvador", dial_code: "+503" },
    { name: "Equatorial Guinea", dial_code: "+240" },
    { name: "Eritrea", dial_code: "+291" },
    { name: "Estonia", dial_code: "+372" },
    { name: "Ethiopia", dial_code: "+251" },
    { name: "Falkland Islands", dial_code: "+500" },
    { name: "Faroe Islands", dial_code: "+298" },
    { name: "Fiji", dial_code: "+679" },
    { name: "Finland", dial_code: "+358" },
    { name: "France", dial_code: "+33" },
    { name: "French Polynesia", dial_code: "+689" },
    { name: "Gabon", dial_code: "+241" },
    { name: "Gambia", dial_code: "+220" },
    { name: "Georgia", dial_code: "+995" },
    { name: "Germany", dial_code: "+49" },
    { name: "Ghana", dial_code: "+233" },
    { name: "Gibraltar", dial_code: "+350" },
    { name: "Greece", dial_code: "+30" },
    { name: "Greenland", dial_code: "+299" },
    { name: "Grenada", dial_code: "+1-473" },
    { name: "Guam", dial_code: "+1-671" },
    { name: "Guatemala", dial_code: "+502" },
    { name: "Guinea", dial_code: "+224" },
    { name: "Guinea-Bissau", dial_code: "+245" },
    { name: "Guyana", dial_code: "+592" },
    { name: "Haiti", dial_code: "+509" },
    { name: "Honduras", dial_code: "+504" },
    { name: "Hong Kong", dial_code: "+852" },
    { name: "Hungary", dial_code: "+36" },
    { name: "Iceland", dial_code: "+354" },
    { name: "India", dial_code: "+91" },
    { name: "Indonesia", dial_code: "+62" },
    { name: "Iran", dial_code: "+98" },
    { name: "Iraq", dial_code: "+964" },
    { name: "Ireland", dial_code: "+353" },
    { name: "Israel", dial_code: "+972" },
    { name: "Italy", dial_code: "+39" },
    { name: "Jamaica", dial_code: "+1-876" },
    { name: "Japan", dial_code: "+81" },
    { name: "Jordan", dial_code: "+962" },
    { name: "Kazakhstan", dial_code: "+7" },
    { name: "Kenya", dial_code: "+254" },
    { name: "Kiribati", dial_code: "+686" },
    { name: "Kuwait", dial_code: "+965" },
    { name: "Kyrgyzstan", dial_code: "+996" },
    { name: "Laos", dial_code: "+856" },
    { name: "Latvia", dial_code: "+371" },
    { name: "Lebanon", dial_code: "+961" },
    { name: "Lesotho", dial_code: "+266" },
    { name: "Liberia", dial_code: "+231" },
    { name: "Libya", dial_code: "+218" },
    { name: "Liechtenstein", dial_code: "+423" },
    { name: "Lithuania", dial_code: "+370" },
    { name: "Luxembourg", dial_code: "+352" },
    { name: "Macau", dial_code: "+853" },
    { name: "Macedonia", dial_code: "+389" },
    { name: "Madagascar", dial_code: "+261" },
    { name: "Malawi", dial_code: "+265" },
    { name: "Malaysia", dial_code: "+60" },
    { name: "Maldives", dial_code: "+960" },
    { name: "Mali", dial_code: "+223" },
    { name: "Malta", dial_code: "+356" },
    { name: "Marshall Islands", dial_code: "+692" },
    { name: "Mauritania", dial_code: "+222" },
    { name: "Mauritius", dial_code: "+230" },
    { name: "Mexico", dial_code: "+52" },
    { name: "Micronesia", dial_code: "+691" },
    { name: "Moldova", dial_code: "+373" },
    { name: "Monaco", dial_code: "+377" },
    { name: "Mongolia", dial_code: "+976" },
    { name: "Montenegro", dial_code: "+382" },
    { name: "Morocco", dial_code: "+212" },
    { name: "Mozambique", dial_code: "+258" },
    { name: "Myanmar", dial_code: "+95" },
    { name: "Namibia", dial_code: "+264" },
    { name: "Nauru", dial_code: "+674" },
    { name: "Nepal", dial_code: "+977" },
    { name: "Netherlands", dial_code: "+31" },
    { name: "New Zealand", dial_code: "+64" },
    { name: "Nicaragua", dial_code: "+505" },
    { name: "Niger", dial_code: "+227" },
    { name: "Nigeria", dial_code: "+234" },
    { name: "North Korea", dial_code: "+850" },
    { name: "Norway", dial_code: "+47" },
    { name: "Oman", dial_code: "+968" },
    { name: "Pakistan", dial_code: "+92" },
    { name: "Palau", dial_code: "+680" },
    { name: "Palestine", dial_code: "+970" },
    { name: "Panama", dial_code: "+507" },
    { name: "Papua New Guinea", dial_code: "+675" },
    { name: "Paraguay", dial_code: "+595" },
    { name: "Peru", dial_code: "+51" },
    { name: "Philippines", dial_code: "+63" },
    { name: "Poland", dial_code: "+48" },
    { name: "Portugal", dial_code: "+351" },
    { name: "Puerto Rico", dial_code: "+1-787" },
    { name: "Qatar", dial_code: "+974" },
    { name: "Romania", dial_code: "+40" },
    { name: "Russia", dial_code: "+7" },
    { name: "Rwanda", dial_code: "+250" },
    { name: "Saint Kitts and Nevis", dial_code: "+1-869" },
    { name: "Saint Lucia", dial_code: "+1-758" },
    { name: "Saint Vincent", dial_code: "+1-784" },
    { name: "Samoa", dial_code: "+685" },
    { name: "San Marino", dial_code: "+378" },
    { name: "Saudi Arabia", dial_code: "+966" },
    { name: "Senegal", dial_code: "+221" },
    { name: "Serbia", dial_code: "+381" },
    { name: "Seychelles", dial_code: "+248" },
    { name: "Sierra Leone", dial_code: "+232" },
    { name: "Singapore", dial_code: "+65" },
    { name: "Slovakia", dial_code: "+421" },
    { name: "Slovenia", dial_code: "+386" },
    { name: "Solomon Islands", dial_code: "+677" },
    { name: "Somalia", dial_code: "+252" },
    { name: "South Africa", dial_code: "+27" },
    { name: "South Korea", dial_code: "+82" },
    { name: "Spain", dial_code: "+34" },
    { name: "Sri Lanka", dial_code: "+94" },
    { name: "Sudan", dial_code: "+249" },
    { name: "Suriname", dial_code: "+597" },
    { name: "Swaziland", dial_code: "+268" },
    { name: "Sweden", dial_code: "+46" },
    { name: "Switzerland", dial_code: "+41" },
    { name: "Syria", dial_code: "+963" },
    { name: "Taiwan", dial_code: "+886" },
    { name: "Tajikistan", dial_code: "+992" },
    { name: "Tanzania", dial_code: "+255" },
    { name: "Thailand", dial_code: "+66" },
    { name: "Togo", dial_code: "+228" },
    { name: "Tonga", dial_code: "+676" },
    { name: "Trinidad and Tobago", dial_code: "+1-868" },
    { name: "Tunisia", dial_code: "+216" },
    { name: "Turkey", dial_code: "+90" },
    { name: "Turkmenistan", dial_code: "+993" },
    { name: "Uganda", dial_code: "+256" },
    { name: "Ukraine", dial_code: "+380" },
    { name: "United Arab Emirates", dial_code: "+971" },
    { name: "United Kingdom", dial_code: "+44" },
    { name: "United States", dial_code: "+1" },
    { name: "Uruguay", dial_code: "+598" },
    { name: "Uzbekistan", dial_code: "+998" },
    { name: "Vanuatu", dial_code: "+678" },
    { name: "Vatican City", dial_code: "+379" },
    { name: "Venezuela", dial_code: "+58" },
    { name: "Vietnam", dial_code: "+84" },
    { name: "Yemen", dial_code: "+967" },
    { name: "Zambia", dial_code: "+260" },
    { name: "Zimbabwe", dial_code: "+263" }
  ];
  const dialCodes = [
    "+93", "+355", "+213", "+376", "+244", "+54", "+374", "+61", "+43", "+994",
    "+1-242", "+973", "+880", "+375", "+32", "+975", "+591", "+387", "+55",
    "+673", "+359", "+855", "+237", "+1", "+56", "+86", "+57", "+506", "+385",
    "+53", "+357", "+420", "+45", "+1-809", "+593", "+20", "+503", "+240",
    "+291", "+372", "+251", "+358", "+33", "+241", "+220", "+995", "+49",
    "+233", "+30", "+299", "+502", "+224", "+245", "+592", "+509", "+504",
    "+852", "+36", "+354", "+91", "+62", "+98", "+964", "+353", "+972", "+39",
    "+225", "+81", "+962", "+7", "+254", "+686", "+965", "+996", "+856",
    "+371", "+961", "+266", "+231", "+218", "+423", "+370", "+352", "+853",
    "+389", "+261", "+265", "+60", "+960", "+223", "+356", "+692", "+222",
    "+230", "+52", "+691", "+373", "+377", "+976", "+382", "+212", "+258",
    "+95", "+264", "+674", "+977", "+31", "+599", "+687", "+64", "+505",
    "+227", "+234", "+683", "+850", "+47", "+968", "+92", "+680", "+507",
    "+675", "+595", "+51", "+63", "+48", "+351", "+1-787", "+974", "+40",
    "+7", "+250", "+290", "+1-869", "+1-758", "+508", "+1-784", "+685",
    "+378", "+239", "+966", "+221", "+381", "+248", "+232", "+65", "+421",
    "+386", "+677", "+252", "+27", "+82", "+34", "+94", "+249", "+597",
    "+268", "+46", "+41", "+963", "+886", "+992", "+255", "+66", "+670",
    "+228", "+676", "+1-868", "+216", "+90", "+993", "+688", "+256", "+380",
    "+971", "+44", "+1", "+598", "+998", "+678", "+58", "+84", "+681", "+967",
    "+260", "+263"
  ];

  const loadOptionsDisrcit = async (search, loadedOptions, pages) => {
    console.log(loadedOptions);
    console.log(pages);
    const response = await fetch(
      URL.API_BASE_URL +
      `/publicApi/searchareaDistricts?key=${search}&page=${pages?.page}&States_id=${stateselect?.State}`
    );
    const responseJSON = await response.json();

    const options = responseJSON?.results?.map((data) => {
      data.value = data?._id;
      data.label = data?.District;

      return data;
    });

    return {
      options: options,
      hasMore: responseJSON.has_more,
      additional: {
        page: pages?.page + 1,
      },
    };
  };

  const loadOptionsCity = async (search, loadedOptions, pages) => {
    console.log(loadedOptions);
    console.log(pages);
    const response = await fetch(
      URL.API_BASE_URL +
      `/publicApi/searchareacity?key=${search}&page=${pages?.page}&District_id=${districtselect?.District}`
    );
    const responseJSON = await response.json();

    const options = responseJSON?.results?.map((data) => {
      data.value = data?._id;
      data.label = data?.Area + ", " + data?.Pincode;

      return data;
    });

    return {
      options: options,
      hasMore: responseJSON.has_more,
      additional: {
        page: pages?.page + 1,
      },
    };
  };

  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [error, setError] = useState(null);

  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);

          // Send the location to your server
          // axios
          //   .post("http://localhost:3000/location", {
          //     latitude: position.coords.latitude,
          //     longitude: position.coords.longitude,
          //   })
          //   .then((response) => {
          //     console.log(response.data);
          //   })
          //   .catch((error) => {
          //     console.error("There was an error sending the location!", error);
          //   });
        },
        (error) => {
          setError(error.message);
        }
      );
    } else {
      setError("Geolocation is not supported by this browser.");
    }
  };

  const [referName, setreferName] = useState("");
  const [referID, setreferID] = useState("");
  console.log(referName);
  const hendlereferCheck = async (e) => {
    setreferID(e);
    try {
      // let uppercaseStr = loginData?.phone.toUpperCase();
      const response = await Api.post(`${URL.referCheck}`, {
        referBy: e?.toUpperCase(),
      });

      console.log(response);

      if (response?.data?.success) {
        setreferName(response?.data?.data?.fullName);
      } else {
        setreferName("");
        // toast.error("invalid refer code");
      }
    } catch (error) {
      console.log(error);
      toast.error("invalid refer code");
    }
  };

  const hendleverifysec = async (e) => {
    e?.preventDefault();
    if (!userData?.fullName) {
      toast.error("Full Name Required");
    } else if (!userData?.phone) {
      toast.error("please enter phone");
    }
    // else if (userData?.phone?.length !== 10) {
    //   toast.error("invalid phone number");
    // } 
    else if (!userData?.email) {
      toast.error("Email Required");
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(userData?.email)
    ) {
      toast.error("Email  Invalid");
    } else if (!userData?.confirmPassword) {
      toast.error("Confirm Password Required");
    } else if (!userData?.password) {
      toast.error("Password Required");
    } else if (userData?.password !== userData?.confirmPassword) {
      toast.error("Password not Match");
    }
    // else if (!cityselect?.Area) {
    //   toast.error("please enter city");
    // } 
    // else if (!stateselect?.State) {
    //   toast.error("please enter state");
    // } 
    // else if (!cityselect?.Pincode) {
    //   toast.error("please enter zip");
    // } 
  /*   else if (!referName) {
      toast.error("please enter sponsor code");
    } */ /*  else if (!userData?.side) {
      toast.error("Please select club");
    }  */ else {
      // if (userData?.nomineeName) {
      //   if (!userData?.nomineeRelation) {
      //     toast.error("please select nominee relation");
      //     return;
      //   }
      // }
      // if (userData?.nomineeRelation) {
      //   if (!userData?.nomineeName) {
      //     toast.error("please enter nominee name");
      //     return;
      //   }
      // }
      // userData.referBy = referID;
      // referID
      // otpVerifyuser


      // if (referID) {
      //    if (!referName) {
      //       toast.error("please enter sponsor code");
      //       return;
      //     } 
      // }
      const fainaldata = {
        fullName: userData?.fullName,
        phone: userData?.phone,
        password: userData?.password,
        nomineeRelation: userData?.nomineeRelation,
        nomineeName: userData?.nomineeName,
        district: districtselect?.District,
        city: cityselect?.Area,
        state: stateselect?.State,
        zip: cityselect?.Pincode,
        // zip: cityselect?.Pincode,
        location_id: cityselect?._id,
        country: userData?.country,
        email: userData?.email,
        // side: userData?.side,
        displayName: userData?.displayName,
        referBy: referID ? referID : "00001",
        role_name: type,
        // longitude: longitude,
        // latitude: latitude,
        // referBy: referID,
        otp: userData?.otp,
      };
      if (longitude) {
        fainaldata.longitude = longitude;
      }
      if (latitude) {
        fainaldata.latitude = latitude;
      }
      const response = await Api.post(`${URL.otpVerifyuser}`, fainaldata);
      if (response?.data?.success) {
        // setotpBox("1");
        // setregisterDetails(response?.data?.data);
        route("/login");
        toast.success(response?.data?.message);
      } else {
        toast.error(response?.data?.message);
      }
      // dispatch(allapiAction.signupSeller(userData));
      // return () => {};
    }
  };

  useEffect(() => {
    dispatch(allapiAction.getsliderList({ page: "registerpage" }));

    return () => { };
  }, []);

  const handleNext = async (i) => {
    try {
      const fainaldata = {
        fullName: "ganesh" + (1 + i),
        phone: "123456123" + (1 + i),
        password: "123456",
        nomineeRelation: "mother",
        nomineeName: "gita" + (1 + i),
        district: districtselect?.District,
        city: cityselect?.Area,
        state: stateselect?.State,
        zip: cityselect?.Pincode,
        // zip: cityselect?.Pincode,
        location_id: cityselect?._id,
        country: userData?.country,
        email: "ganesh" + (1 + i) + "@gmail.com",
        // side: userData?.side,
        displayName: userData?.displayName,
        referBy: "00001",
        role_name: type,
        // longitude: longitude,
        // latitude: latitude,
        // referBy: referID,
        otp: "123456",
      };
      if (longitude) {
        fainaldata.longitude = longitude;
      }
      if (latitude) {
        fainaldata.latitude = latitude;
      }
      const response = await Api.post(`${URL.otpVerifyuser}`, fainaldata);
      return true;
    } catch (error) {
      console.log(error);

      return true;
    }
  };

  const newuserRegister = async () => {
    const userData = Array.from({ length: 50 }, (_, i) => i + 1);
    for (const [index, value] of Object.entries(userData)) {
      console.log(index);

      await handleNext(index);
    }
  };
  return (
    <div className="my-5">
      <div className="hometest">
        <RegisaterSlider sliderlist={slider} />
      </div>
      {/* <button
        class="ps-btn ps-btn--fullwidth"
        onClick={(e) => {
          newuserRegister(e);
        }}
      >
        Register
      </button> */}
      <div className="container pt-4">
        <div className="my-5 mb-5">
          <div className="row">
            <div className="col-sm-12 col-12 ">
              {/* <ul className="ps-tab-list">
                <li className={type == "User" ? "active" : ""}>
                  <a
                    href="#"
                    onClick={() => {
                      settype("User");
                    }}
                  >
                    User
                  </a>
                </li>
                <li className={type == "Vendor" ? "active" : ""}>
                  <a
                    href="#"
                    onClick={() => {
                      settype("Vendor");
                    }}
                  >
                    Vendor
                  </a>
                </li>
              </ul> */}
              {/* {type == "User" ? (
                <h2 className="text-center">Customer Registration</h2>
              ) : (
                <h2 className="text-center">Vendor Registration</h2>
              )} */}

              {otp_box == "1" ? (
                <div className="card p-4">
                  <div className="row">
                    <div className="col-6">
                      <div className="form-group">
                        <label>Full Name</label>
                        <input
                          type=""
                          className="form-control"
                          name="fullName"
                          value={userData?.fullName}
                          onChange={(e) => {
                            hendletochange(e);
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                      <div className="form-group">
                        <label>Phone</label>
                        <div style={{ display: "flex", width: "100%", flexWrap: "nowrap" }}>
                          {/* Dial code dropdown */}
                          <select
                            name="dialCode"
                            value={userData?.dialCode || "+91"}
                            onChange={(e) => hendletochange(e)}
                            style={{
                              flex: "0 0 90px",
                              maxWidth: "100px",
                              border: "1px solid #ced4da",
                              borderRight: "none",
                              borderRadius: "5px 0 0 5px",
                              padding: "8px",
                              background: "#fff",
                              maxHeight: "200px",  
                              overflowY: "auto",   
                              appearance: "none",  
                              WebkitAppearance: "none",
                              MozAppearance: "none"
                            }}
                            size={8}  // 👈 ek time pe 8 options visible rahenge
                          >
                            {dialCodes.map((code, index) => (
                              <option key={index} value={code}>
                                {code}
                              </option>
                            ))}
                          </select>

                          {/* Phone number input */}
                          <input
                            type="tel"
                            name="phone"
                            value={userData?.phone || ""}
                            onChange={(e) => hendletochange(e)}
                            style={{
                              flex: "1 1 auto",
                              minWidth: "0",
                              border: "1px solid #ced4da",
                              borderRadius: "0 5px 5px 0",
                              padding: "8px"
                            }}
                          />
                        </div>
                      </div>
                    </div>


                  </div>

                  <div className="form-group submtit">
                    <button
                      onClick={(e) => {
                        hendletoSubmit(e);
                      }}
                      className="ps-btn ps-btn--fullwidth"
                    >
                      Send otp
                    </button>
                  </div>
                </div>
              ) : otp_box == "2" ? (
                <>
                  <h1>Wellcome message show krna hai </h1>
                </>
              ) : (
                <form
                  // action=""
                  className="ps-form--account2 ps-tab-root registerfm mkkk bg-black-opicity"
                >
                  <ul className="ps-tab-list">
                    <li
                      onClick={() => {
                        settype("User");
                      }}
                      className={
                        type == "User" ? "active tbbtn login-page" : "tbbtn"
                      }
                    >
                      <a>Sign Up</a>
                    </li>
                    {/* <li
                      className={
                        type == "Vendor" ? "active tbbtn gradient-bg" : " tbbtn"
                      }
                      onClick={() => {
                        settype("Vendor");
                      }}
                    >
                      <a>Vendor</a>
                    </li> */}
                  </ul>
                  <div className="  ">
                    <div className="ps-tab active">
                      <div className="row">
                        <div className=" col-sm-6 col-12">
                          <div class="input-box2">
                            <span class="icon">
                              <ion-icon name="lock-closed"></ion-icon>
                            </span>
                            <label className=" text-white fw-bold">Full Name</label>
                            <input
                              type="text"
                              required
                              className="form-control mannu" style={{padding:"18px"}}
                              name="fullName"
                              value={userData?.fullName}
                              onChange={(e) => {
                                hendletochange(e);
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                          <div className="form-group">
                            <label className="my-3 text-white fw-bold">Phone</label>
                            <div
                              style={{
                                display: "flex",
                                width: "100%",
                                alignItems: "center"
                              }}
                            >
                              {/* Dial code dropdown */}
                              <select className="mannu"
                                name="dialCode"
                                value={userData?.dialCode || "+91"}
                                onChange={(e) => hendletochange(e)}
                                style={{
                                  width: "90px",               // 👈 fixed width
                                  // border: "1px solid #ced4da",
                                  borderRight: "none",
                                  borderRadius: "5px 0 0 5px",
                                  padding: "8px",
                                  background: "#fff"
                                }}
                              >
                                {dialCodes.map((code, index) => (
                                  <option key={index} value={code}>
                                    {code}
                                  </option>
                                ))}
                              </select>

                              {/* Phone number input */}
                              <input className="mannu"
                                type="tel"
                                name="phone"
                                value={userData?.phone || ""}
                                onChange={(e) => hendletochange(e)}
                                style={{
                                  flex: 1,                      // 👈 baaki jagah le lega
                                  // border: "1px solid #ced4da",
                                  // borderRadius: "0 5px 5px 0",
                                  padding: "8px",
                                  minWidth: "0"                 // 👈 flex shrink ke liye
                                }}
                              />
                            </div>
                          </div>
                        </div>



                        <div className=" col-sm-6 col-12">
                          <div class="input-box2">
                            <span class="icon">
                              <ion-icon name="mail"></ion-icon>
                            </span>
                            <label className=" text-white fw-bold">Email</label>
                            <input
                              type="email"
                              required
                              name="email"
                              className="form-control mannu" style={{padding:"18px"}}
                              value={userData?.email}
                              onChange={(e) => {
                                hendletochange(e);
                              }}
                            />
                          </div>
                        </div>
                        {type !== "User" && (
                          <div className=" col-sm-6 col-12">
                            <div class="input-box2">
                              <span class="icon">
                                <ion-icon name="mail"></ion-icon>
                              </span>
                              <label className=" text-white fw-bold">Display Name</label>
                              <input
                                type="text"
                                // required
                                name="displayName"
                                className="form-control mannu"style={{padding:"18px"}}
                                value={userData?.displayName}
                                onChange={(e) => {
                                  hendletochange(e);
                                }}
                              />
                            </div>
                          </div>
                        )}
                        <div className=" col-sm-6 col-12">
                          <div class="input-box2">
                            <span class="icon">
                              <ion-icon name="mail"></ion-icon>
                            </span>
                            <label className="my-3 text-white fw-bold">Password</label>
                            <input
                              type="password"
                              required
                              name="password"
                              className="form-control mannu"style={{padding:"18px"}}
                              value={userData?.password}
                              onChange={(e) => {
                                hendletochange(e);
                              }}
                            />
                          </div>
                        </div>
                        <div className=" col-sm-6 col-12">
                          <div class="input-box2">
                            <span class="icon">
                              <ion-icon name="mail"></ion-icon>
                            </span>

                            <label className="my-3 text-white fw-bold">Confirm Password</label>
                            <input
                              type="password"
                              required
                              name="confirmPassword"
                              className="form-control mannu"style={{padding:"18px"}}
                              value={userData?.confirmPassword}
                              onChange={(e) => {
                                hendletochange(e);
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-sm-6 col-12">
                          <div className="input-box2">
                            <span className="icon">
                              <ion-icon name="call"></ion-icon>
                            </span>
                            <label className="my-3 text-white fw-bold">Country</label>
                            <select
                              required
                              name="country"
                              className="form-control mannu "
                              onChange={(e) => hendletochange(e)}
                            >
                              <option value="" >-- Select Country --</option>
                              {countries.map((c, index) => (
                                <option key={index} value={c.dial_code}>
                                  {c.name} ({c.dial_code})
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        {/* <div className=" col-sm-6 col-12">
                          <div class="input-box2">
                            <span class="icon">
                              <ion-icon name="mail"></ion-icon>
                            </span>
                            <label>State</label>
                            <input
                type="text"
                required
                name="state"
                value={userData?.state}
                onChange={(e) => {
                  hendletochange(e);
                }}
              />

                            <AsyncPaginate
                              value={stateselect}
                              className="liceninput"
                              placeholder="State"
                              loadOptions={loadOptionsState}
                              onChange={setstateselect}
                              additional={{
                                page: 1,
                              }}
                            />

                            <select
                id=""
                className=""
                onChange={(e) => {
                  setState(e?.target?.value);
                }}
              >
                <option value={""}>Select State</option>

                {statesindia &&
                  statesindia?.map((data, i) => {
                    return (
                      <option key={i} value={data?.name}>
                        {data?.name}
                      </option>
                    );
                  })}
              </select>
                          </div>
                        </div> */}
                        {/* <div className=" col-sm-6 col-12">
                          <div class="input-box2">
                            <label>District</label>
                            <AsyncPaginate
                              key={mangeKey}
                              value={districtselect}
                              className="liceninput"
                              placeholder="District"
                              loadOptions={loadOptionsDisrcit}
                              onChange={setdistrictselect}
                              additional={{
                                page: 1,
                              }}
                            />
                             <span class="icon">
                <ion-icon name="mail"></ion-icon>
              </span>
              <input
                type="text"
                required
                name="district"
                value={userData?.district}
                onChange={(e) => {
                  hendletochange(e);
                }}
              />
                          </div> 
                        </div> */}
                        <div className=" col-sm-6 col-12">
                          <div class="input-box2">
                            <span class="icon">
                              <ion-icon name="mail"></ion-icon>
                            </span>

                            <label className="my-3 text-white fw-bold">City</label>
                            {/* <AsyncPaginate
                              key={mangeKey2}
                              value={cityselect}
                              className="liceninput"
                              placeholder="City"
                              loadOptions={loadOptionsCity}
                              onChange={setcityselect}
                              additional={{
                                page: 1,
                              }}
                            /> */}
                            <input
                              type="text"
                              required
                              name="city"
                              className="form-control mannu"style={{padding:"18px"}}
                              value={userData?.city}
                              onChange={(e) => {
                                hendletochange(e);
                              }}
                            />
                          </div>
                        </div>
                        {/* <div className=" col-sm-6 col-12">
                          <div class="input-box2">
                            <span class="icon">
                              <ion-icon name="lock-closed"></ion-icon>
                            </span>
                            <label className="my-3 text-white fw-bold">Sponser Code</label>
                            <input
                              type="text"
                              required
                              className="form-control mannu"style={{padding:"18px"}}
                              name="fullName"
                              // value={userData?.fullName}
                              // onChange={(e) => {
                              //   hendlereferCheck(e);
                              // }}
                              onBlur={(e) => {
                                hendlereferCheck(e?.target?.value);
                              }}
                            />
                          </div>
                        </div>
                        <div className=" col-sm-6 col-12">
                          <div class="input-box2">
                            <span class="icon">
                              <ion-icon name="lock-closed"></ion-icon>
                            </span>
                            <label className="my-3 text-white fw-bold">Sponser Name</label>
                            <input
                              type="text"
                              required
                              className="form-control mannu"style={{padding:"18px"}}
                              name="fullName"
                              value={referName}
                            // onChange={(e) => {
                            //   hendletochange(e);
                            // }}
                            />
                          </div>
                        </div> */}
                        {/* <div className=" col-sm-6 col-12">
                          <div class="input-box2">
                            <span class="icon">
                              <ion-icon name="lock-closed"></ion-icon>
                            </span>
                            <label>Nominee Reletion</label>
                            <input
                              type="text"
                              required
                              className="form-control"
                              name="nomineeName"
                              value={userData?.nomineeName}
                              onChange={(e) => {
                                hendletochange(e);
                              }}
                            />
                            <select
                              className="form-control"
                              name="nomineeRelation"
                              value={userData?.nomineeRelation}
                              onChange={(e) => {
                                hendletochange(e);
                              }}
                            >
                              <option value={""}>Select Relation</option>
                              <option value={"Father"}>Father</option>
                              <option value={"Mother"}>Mother</option>
                              <option value={"Sister"}>Sister</option>
                              <option value={"Daughter"}>Daughter</option>
                            </select>
                          </div>
                        </div> */}
                        {/* <div className=" col-sm-6 col-12">
                          <div class="input-box2">
                            <span class="icon">
                              <ion-icon name="lock-closed"></ion-icon>
                            </span>
                            <label>Nominee Name</label>
                            <input
                              type="text"
                              required
                              className="form-control"
                              name="nomineeName"
                              value={userData?.nomineeName}
                              onChange={(e) => {
                                hendletochange(e);
                              }}
                            />
                          </div>
                        </div> */}
                        {/* <div className=" col-sm-6 col-12">
                          <div class="input-box2">
                            <span class="icon">
                              <ion-icon name="lock-closed"></ion-icon>
                            </span>
                            <label>Select Club</label>
                            <select
                              id=""
                              className="form-control"
                              name="side"
                              onChange={(e) => {
                                hendletochange(e);
                              }}
                            >
                              <option value={""}>Select Club</option>
                              <option value={"left"}>Left</option>
                              <option value={"right"}>Right</option>
                            </select>
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </div>

                  {/* <div class="input-box2">
              <span class="icon">
                <ion-icon name="lock-closed"></ion-icon>
              </span>
              <input
                type="number"
                required
                name="otp"
                value={userData?.otp}
                onChange={(e) => {
                  hendletochange(e);
                }}
              />
              <label>Otp</label>
            </div> */}

                  {/* <div class="input-box2">
              <span class="icon">
                <ion-icon name="mail"></ion-icon>
              </span>
              <input
                type="text"
                required
                name="zip"
                value={userData?.zip}
                onChange={(e) => {
                  hendletochange(e);
                }}
              />
              <label>Zip</label>
            </div> */}

                  {/* <button
                    type="submit"
                    onClick={(e) => {
                      hendleverifysec(e);
                    }}
                  >
                    Submit
                  </button> */}
                  <div class="mt-15"></div>
                  <div class="form-group submtit">
                    <button
                      class="ps-btn ps-btn--fullwidth"
                      onClick={(e) => {
                        hendleverifysec(e);
                      }}
                    >
                      Register
                    </button>
                  </div>

                  <div class="register-link">
                    <p className="text-white fw-bold">
                      You have an account? <Link className="text-warning fw-bold" to="/login">Login</Link>
                    </p>
                  </div>
                </form>
              )}
            </div>
            {/* <div className="col-sm-6">
              <div className="ps-section__right row">
                <div className="col-sm-12 col-12 adsboxcus1">
                  {ad && (
                    <Slider {...settings}>
                      {ad &&
                        ad?.map((data, i) => {
                          return (
                            <div key={i}>
                              <a className="ps-collection" href="#">
                                <img
                                  src={URL?.API_BASE_URL + data?.image}
                                  alt=""
                                />
                              </a>
                            </div>
                          );
                        })}
                    </Slider>
                  )}
                </div>
                <div className="col-sm-12 col-12 adsboxcus1">
                  {ads2 && (
                    <Slider {...settings}>
                      {ads2 &&
                        ads2?.map((data, i) => {
                          return (
                            <div key={i}>
                              <a className="ps-collection" href="#">
                                <img
                                  src={URL?.API_BASE_URL + data?.image}
                                  alt=""
                                />
                              </a>
                            </div>
                          );
                        })}
                    </Slider>
                  )}
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>

      <div className="hometest">
        <RegisaterSlider sliderlist={ads2} />
      </div>
    </div>
  );
}

export default RegisterComponent;
